/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wu_c_master_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From M, A, S, T, E, R you get the full anagrams STREAM, TAMERS, and MATERS, plus shorter words like TEAM, RATE, TEAR, SEAT, MATE, ARM, and EAT — all spelled using only letters MASTER already contains.`)
};

const es_wu_c_master_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A partir de M, A, S, T, E, R obtienes los anagramas completos STREAM, TAMERS y MATERS, además de palabras más cortas como TEAM, RATE, TEAR, SEAT, MATE, ARM y EAT —todas formadas solo con letras que MASTER ya contiene.`)
};

const de_wu_c_master_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aus M, A, S, T, E, R ergeben sich die vollständigen Anagramme STREAM, TAMERS und MATERS, dazu kürzere Wörter wie TEAM, RATE, TEAR, SEAT, MATE, ARM und EAT — alle nur mit Buchstaben geschrieben, die MASTER bereits enthält.`)
};

const nl_wu_c_master_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uit M, A, S, T, E, R krijg je de volledige anagrammen STREAM, TAMERS en MATERS, plus kortere woorden zoals TEAM, RATE, TEAR, SEAT, MATE, ARM en EAT — allemaal gespeld met alleen letters die MASTER al bevat.`)
};

const fr_wu_c_master_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avec M, A, S, T, E, R, on obtient les anagrammes complètes STREAM, TAMERS et MATERS, ainsi que des mots plus courts comme TEAM, RATE, TEAR, SEAT, MATE, ARM et EAT — tous formés uniquement à partir des lettres déjà présentes dans MASTER.`)
};

const it_wu_c_master_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Da M, A, S, T, E, R ottieni gli anagrammi completi STREAM, TAMERS e MATERS, oltre a parole più corte come TEAM, RATE, TEAR, SEAT, MATE, ARM e EAT — tutte scritte usando solo lettere già contenute in MASTER.`)
};

const pt_br2_wu_c_master_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A partir de M, A, S, T, E, R você obtém os anagramas completos STREAM, TAMERS e MATERS, além de palavras mais curtas como TEAM, RATE, TEAR, SEAT, MATE, ARM e EAT — todas formadas usando apenas letras que MASTER já contém.`)
};

const pt_wu_c_master_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A partir de M, A, S, T, E, R obtêm-se os anagramas completos STREAM, TAMERS e MATERS, além de palavras mais curtas como TEAM, RATE, TEAR, SEAT, MATE, ARM e EAT — todas soletradas apenas com letras que MASTER já contém.`)
};

const ja_wu_c_master_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`M, A, S, T, E, Rからは、完全なアナグラムであるSTREAM、TAMERS、MATERSに加え、TEAM、RATE、TEAR、SEAT、MATE、ARM、EATなどの短い単語も作れます — いずれもMASTERにすでに含まれる文字だけで綴られています。`)
};

const zh_wu_c_master_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用 M、A、S、T、E、R 可以拼出完整的易位构词 STREAM、TAMERS 和 MATERS，还有更短的单词，比如 TEAM、RATE、TEAR、SEAT、MATE、ARM 和 EAT——全部只用到 MASTER 本身已有的字母。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wu_c_master_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wu_c_master_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wu_c_master_faq2_a", locale)
	if (locale === "en") return en_wu_c_master_faq2_a(inputs)
	if (locale === "es") return es_wu_c_master_faq2_a(inputs)
	if (locale === "de") return de_wu_c_master_faq2_a(inputs)
	if (locale === "nl") return nl_wu_c_master_faq2_a(inputs)
	if (locale === "fr") return fr_wu_c_master_faq2_a(inputs)
	if (locale === "it") return it_wu_c_master_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_wu_c_master_faq2_a(inputs)
	if (locale === "pt") return pt_wu_c_master_faq2_a(inputs)
	if (locale === "ja") return ja_wu_c_master_faq2_a(inputs)
	return zh_wu_c_master_faq2_a(inputs)
};